'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var gallerySwitcher = function gallerySwitcher($, newConfig, responsive) {
    var context = {};
    context.config = {
        gallerySelector: '.js-main-gallery',
        icoSelectorThumbs: '.js-gallerySwitchIco-Thumbs',
        icoSelectorList: '.js-gallerySwitchIco-List',
        icoActiveClass: 'ui-btn_major',
        galleryClassThumbs: 'storyGallery-tiles',
        galleryClassList: 'storyGallery-list'
    };

    $.extend(context.config, newConfig);

    $(context.config.icoSelectorThumbs).on('click', function (e) {
        e.preventDefault();
        if (!$(context.config.icoSelectorThumbs).hasClass(context.config.icoActiveClass)) {
            $(context.config.icoSelectorThumbs).addClass(context.config.icoActiveClass).siblings().removeClass(context.config.icoActiveClass);
            $(context.config.gallerySelector).removeClass(context.config.galleryClassList).addClass(context.config.galleryClassThumbs);
        }
        responsive.config = {
            extraNarrow: 'br-n',
            narrow: 'br-n',
            medium: 'br-n',
            wide: 'br-m',
            extraWide: 'br-n'
        };
        $(window.document).trigger('breakPoint.changed', [responsive.currentBreakPoint]);
        return false;
    });

    $(context.config.icoSelectorList).on('click', function (e) {
        e.preventDefault();
        if (!$(context.config.icoSelectorList).hasClass(context.config.icoActiveClass)) {
            $(context.config.icoSelectorList).addClass(context.config.icoActiveClass).siblings().removeClass(context.config.icoActiveClass);
            $(context.config.gallerySelector).removeClass(context.config.galleryClassThumbs).addClass(context.config.galleryClassList);
        }
        responsive.config = {
            extraNarrow: 'br-m',
            narrow: 'br-m',
            medium: 'br-w',
            wide: 'br-w',
            extraWide: 'br-w'
        };
        $(window.document).trigger('breakPoint.changed', [responsive.currentBreakPoint]);
        return false;
    });

    return context;
};

exports.default = gallerySwitcher;


//////////////////
// WEBPACK FOOTER
// ./public/js/gallerySwitcher.js
// module id = 627
// module chunks = 0